import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Card,
  Form,
  Button,
  Table,
  Row,
  Col,
} from "react-bootstrap";
import { fetchApprovedCompanies, deleteApprovedCompany } from "../../services/approvedCompanies";
import { _swal } from "../../utils/helper";

function ApprovedCompaniesList() {
  const [approvedCompaniesData, setApprovedCompaniesData] = useState({});
  const searchSchema = {
    name: null,
  };
  const [ApprovedCompanySearchValues, setApprovedCompanySearchValues] =
    useState(searchSchema);
  const _fetchApprovedCompanies = async (queryParams = {}) => {
    await fetchApprovedCompanies(queryParams)
      .then((response) => {
        const { data } = response;
        setApprovedCompaniesData(data.data.approved_companies);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const _deleteApprovedCompany = async (id) => {
    const _confirm = window.confirm("Are you sure to delete?");
    if (_confirm) {
      await deleteApprovedCompany(id)
        .then((response) => {
          const { data } = response;
          _swal(response.data.status, response.data.message);
          _fetchApprovedCompanies();
        })
        .catch((err) => {
          _swal(err.response.data.status, err.response.data.message);
          console.log(err.response.data);
        });
    }
  };
  const resetSearch = () => {
    _fetchApprovedCompanies({
      page: 1,
      per_page: 100,
      sort_column: "id",
      sort_order: "DESC",
    });
  };
  const filterApprovedCompany = (
    page = null,
    sort_column = null,
    sort_order = null
  ) => {
    const filteredKeys = {};
    Object.entries(ApprovedCompanySearchValues).filter((v) => {
      if (v[1] !== null) {
        filteredKeys[v[0]] = v[1];
      }
    });
    _fetchApprovedCompanies({
      ...filteredKeys,
      page: page ? page : 1,
      per_page: 100,
      sort_column: sort_column ? sort_column : "id",
      sort_order: sort_order ? sort_order : "DESC",
    });
  };
  useEffect(() => {
    _fetchApprovedCompanies({
      page: 1,
      per_page: 100,
      sort_column: "id",
      sort_order: "DESC",
    });
  }, []);
  return (
    <Container className="my-2">
      <Card>
        <Card.Header as="h5">
           ApprovedCompanies{" "}
          <Button
            variant="primary"
            as={Link}
            to={"/admin/approved_companies/create"}
            size="sm"
          >
            New
          </Button>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md="4">
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="ApprovedCompany Name"
                    value={
                      ApprovedCompanySearchValues.name !== null
                        ? ApprovedCompanySearchValues.name
                        : ""
                    }
                    onChange={(e) =>
                      setApprovedCompanySearchValues({
                        ...ApprovedCompanySearchValues,
                        name: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button
              onClick={() => filterApprovedCompany()}
              variant="primary"
              className="mr-2"
            >
              Filter
            </Button>
            <Button
              onClick={(e) => {
                setApprovedCompanySearchValues({ ...searchSchema });
                resetSearch();
              }}
              variant="default"
            >
              Reset
            </Button>
          </Form>
        </Card.Body>
      </Card>
      <Table bordered width={"100%"} className="mt-2">
        <thead>
          <tr>
            <th width="25%">ApprovedCompany Name</th>
            <th width="65%">Description</th>
            <th width="10%">Action</th>
          </tr>
        </thead>
        <tbody>
          {approvedCompaniesData.length ? (
            approvedCompaniesData.map((e) => {
              return (
                <tr>
                  <td>{e.name}</td>
                  <td>{e.description}</td>
                  <td>
                    <Button
                      variant="default"
                      as={Link}
                      to={"/admin/approved_companies/" + e.id + "/edit"}
                      size="sm"
                    >
                      Edit
                    </Button>
                    <Button
                      variant="warning"
                      size="sm"
                      onClick={() => _deleteApprovedCompany(e.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={"3"}>ApprovedCompanies not found</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
}

export default ApprovedCompaniesList;
